document.addEventListener("DOMContentLoaded", () => {

  const targetElement = document.querySelector("cart-drawer");
  const observer = new MutationObserver(function (mutationsList, observer) {

    if (mutationsList.length > 0) {

      mutationsList.forEach(mutation => {
        if (mutation.target.classList.contains('drawer__inner')) {
          bundleCheck()
          slider()
          checkCart()
          checkCheckout();
        }
      });
    }
  });

  const config = { childList: true, subtree: true };
  observer.observe(targetElement, config);

  function checkCart(e) {

    console.log(e);



    let samples = 0;
    let standard = 0;
    let bundleProducts = 0;
    let freeGift = 0;


    let youMayPass = true
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('Cart:', cart);
        // You can now access cart details from the 'cart' variable

        cart.items.forEach((item, index) => {


          if (item.properties.hasOwnProperty('Bundle')) {
            bundleProducts += item.quantity
          }

          if (item.properties.hasOwnProperty('Free')) {
            samples += item.quantity
          } else {
            standard++
          }
        })

        console.log('bundleProducts', bundleProducts);

        if (samples > 3) {
          console.log('3 samples');
          youMayPass = false;
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (response) {
              if (response.ok) {
                //reload page
                location.reload();
              } else {
                console.error('Error clearing the cart:', response);
              }
            })
            .catch(function (error) {
              console.error('Fetch error:', error);
            });

        }

        if (samples & !standard) {
          console.log('only samples');
          fetch('/cart/clear.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (response) {
              if (response.ok) {
                //reload page
                location.reload();
              } else {
                console.error('Error clearing the cart:', response);
              }
            })
            .catch(function (error) {
              console.error('Fetch error:', error);
            });
        }

        if (e) {
          if (youMayPass) {

            window.location.href = '/checkout';
          }
        }


      })
      .catch(error => console.error('Error:', error));
  }



  const slider = () => {
    const container = document.querySelectorAll('.cart-upsells-wrap')


    // console.log(container, next, prev);

    container.forEach((container) => {
      const next = container.querySelector('.swiper-button-next')
      const prev = container.querySelector('.swiper-button-prev')

      const swiper = new Swiper(container, {
        slidesPerView: 2,
        spaceBetween: 8,
        navigation: {
          nextEl: next,
          prevEl: prev,
        }
      });
    })
  }

  const bundleCheck = () => {
    const cartItems = document.querySelectorAll('.cart-item');
    let numberOfBundledItems = 0;


    cartItems.forEach((item) => {
      if (item.getAttribute('data-bundle')) {
        numberOfBundledItems++
      }

      if (item.getAttribute('data-free-gift-id') || item.getAttribute('data-free-sample') || item.getAttribute('data-gift-wrapping')) {
        item.querySelector('quantity-input').style.display = 'none';
      }
    })

    if (numberOfBundledItems < 3) {
      const freeGift = document.querySelector('.cart-item[data-free-gift-id]');

      if (freeGift) {
        freeGift.querySelector('.cart-remove-button').click()
      }
    }
  }


  //bundle builder

  bundleCheck()

  if (window.location.search.includes('open-cart')) {
    document.querySelector('#cart-icon-bubble').click()
    const currentURL = window.location.href;
    const newURL = currentURL.split('?')[0];
    history.replaceState({}, document.title, newURL);
  }

  const bundleBuilder = () => {
    const bundleItems = document.querySelectorAll('.bundle__item');

    if (!bundleItems.length) {
      return;
    }

    const addToCartBtn = document.querySelector('.bundle__add-to-cart');
    const freeGiftId = document.querySelector('.bundle').getAttribute('data-free-gift-id');
    const freeGiftTitle = document.querySelector('.bundle').getAttribute('data-free-gift-title');
    const freeGiftImage = document.querySelector('.bundle').getAttribute('data-free-gift-image');
    const bundleCounter = document.querySelector('.js-bundle-counter');
    const selctedItemsWrapper = document.querySelector('.bundle__selected-items');
    const currency = document.querySelector('.bundle').getAttribute('data-currency');


    let payload = []
    let freeGift = false;

    bundleCounter.addEventListener('click', () => {
      document.querySelector('.bundle__holder').classList.toggle('active')
    })


    bundleItems.forEach((item) => {
      const selectBtn = item.querySelector('.bundle__select');

      selectBtn.addEventListener('click', () => {

        selectBtn.classList.toggle('selected');
        const variantId = selectBtn.getAttribute('data-var-id');
        const imageUrl = item.getAttribute('data-image-url');
        const title = item.getAttribute('data-product-title');
        const price = item.getAttribute('data-product-price');
        let total = 0;


        if (selectBtn.classList.contains('selected')) {

          payload.push({
            "id": variantId,
            "quantity": 1,
            "properties": { "Bundle": "✓" },
            "price": price,
            "title": title,
            "image": imageUrl
          })

        } else {
          payload.forEach((item, index) => {

            if (item.id == variantId) {
              payload.splice(index, 1)
            }
          })
        }

        if (!freeGift & payload.length >= 3) {
          freeGift = true;
          payload.push({
            "id": freeGiftId,
            "quantity": 1,
            "properties": { "Your free gift": "✓" },
            "price": 0,
            "title": freeGiftTitle,
            "image": freeGiftImage
          })
        }

        if (freeGift & payload.length < 4) {
          freeGift = false;
          payload.forEach((item, index) => {
            if (item.id == freeGiftId) {
              payload.splice(index, 1)
            }
          })
        }

        if (payload.length) {
          addToCartBtn.classList.add('active')
        } else {
          addToCartBtn.classList.remove('active')
        }

        if (payload.length < 3) {
          bundleCounter.innerHTML = `Add ${3 - payload.length} items to unlock a free gift!`
          document.querySelector('.bundle__selected-item-foc').classList.remove('active')
        } else {
          bundleCounter.innerHTML = 'You have unlocked a free gift!'
          document.querySelector('.bundle__selected-item-foc').classList.add('active')
        }

        selctedItemsWrapper.innerHTML = '';



        payload.forEach((item) => {
          total += parseFloat(item.price)

          if (!item.properties.hasOwnProperty('Your free gift')) {

            selctedItemsWrapper.innerHTML += `
          <div class="bundle__selected-item">
            <div class="image-wrap">
            <img src="${item.image}" alt="">
            </div>
            <div class="text-wrap">                         
              <p>${item.title}</p>
              <p>${currency}${(item.price / 100).toFixed(2)}</p>   
            </div>            
          </div>
          `
          }

        })
        addToCartBtn.querySelector('p').innerText = `Add to cart ${currency}${(total / 100).toFixed(2)}`
      })


    })

    addToCartBtn.addEventListener('click', () => {
      const items = { "items": payload }
      const url = `/cart/add.js`;
      addToCartBtn.classList.add('loading')

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(items),
      })
        .then((response) => {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          if (window.location.href.includes('?open-cart')) {
            location.reload();
          } else {
            let url = window.location.href + '?open-cart';
            window.location.href = url;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    })
  }

  bundleBuilder()
  slider()

  const checkCheckout = () => {
    const checkoutBtns = document.querySelectorAll('.cart__checkout-button');

    checkoutBtns.forEach((btn) => {
      console.log(btn);

      btn.addEventListener('click', (e) => {
        console.log('clicked');
        btn.classList.add('loading')

        e.preventDefault();

        checkCart(e)



      });
    });
  }

  checkCheckout();


});









